import React from 'react';

export const PageHeader = ({ overline, title, description, actions, testId }) => (
  <header className="flex items-start justify-between gap-6 mb-8" data-testid={testId || 'page-header'}>
    <div>
      {overline && <div className="overline mb-3">{overline}</div>}
      <h1 className="font-heading font-bold text-4xl tracking-tight leading-[1.05]">
        {title}
      </h1>
      {description && (
        <p className="mt-3 text-[14px] text-[#575757] max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0 pt-1">{actions}</div>}
  </header>
);

export default PageHeader;
